// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ImportOutlinedSvg from "@fishx/icons-svg/es/asn/ImportOutlined";
import FishxIcon from '../components/FishxIcon';

var ImportOutlined = function ImportOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ImportOutlinedSvg
  }));
};

ImportOutlined.displayName = 'ImportOutlined';
export default React.forwardRef(ImportOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ImportOutlined.js
// module id = 2959
// module chunks = 0